module.exports = __webpack_public_path__ + "img/umbler.0aa3b455.png";